/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { thankYouScreenBulkUpdate } from '../../axios/thankYouScreenBulkUpdate'
import type {
	ThankYouScreenBulkUpdateError,
	ThankYouScreenBulkUpdatePathParams,
	ThankYouScreenBulkUpdateRequest,
	ThankYouScreenBulkUpdateResponse,
} from '../../types/ThankYouScreenBulkUpdate'

export const thankYouScreenBulkUpdateMutationKey = () => [{ url: '/campaigns/:campaign/thank-you-screens' }] as const

export type ThankYouScreenBulkUpdateMutationKey = ReturnType<typeof thankYouScreenBulkUpdateMutationKey>

export type ThankYouScreenBulkUpdateVariables = {
	campaign: ThankYouScreenBulkUpdatePathParams['campaign']
	data: ThankYouScreenBulkUpdateRequest
}

/** @see backend/nexus/modules/Form/Http/Controllers/ThankYouScreenController.php ThankYouScreenController::bulkUpdate */
export function useThankYouScreenBulkUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		ThankYouScreenBulkUpdateResponse,
		AxiosError<ThankYouScreenBulkUpdateError>,
		ThankYouScreenBulkUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: thankYouScreenBulkUpdateMutationKey(),
		mutationFn: ({ campaign, data }: ThankYouScreenBulkUpdateVariables) =>
			thankYouScreenBulkUpdate(campaign, data, config).then(res => res.data),
		...options,
	})
}
